import { UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { ActiveUploadsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const ACTIVE_UPLOADS_QUERY = graphql(`
  query activeUploads {
    activeUploads {
      hasActiveUploads
      groups {
        source
        operationId
        documents {
          id
          fileName
          status
          createdAt
        }
        totalCount
        processedCount
      }
    }
  }
`);

export type ActiveUploadGroup = NonNullable<ActiveUploadsQuery["activeUploads"]["groups"]>[number];

export function useActiveUploads(
  options?: Omit<
    UseQueryOptions<ActiveUploadsQuery, unknown, ActiveUploadsQuery>,
    "queryKey" | "queryFn"
  >,
) {
  const { data, ...rest } = useGraphQlQuery(["activeUploads"], ACTIVE_UPLOADS_QUERY, [{}], {
    refetchOnWindowFocus: true,
    staleTime: 300000, // 5 minutes
    ...options,
  });

  return {
    data: data?.activeUploads,
    hasActiveUploads: data?.activeUploads?.hasActiveUploads ?? false,
    groups: data?.activeUploads?.groups ?? [],
    ...rest,
  };
}
